import CountryCodeList from "@/utils/country-code-list.js";

var initCap = function(str) {
  if(str && str.length > 0) {
    return str[0].toUpperCase() + str.substring(1, str.length).toLowerCase();
  }
  return str;
}

export default {
  bankAccountOutputFields() {
    return [
      {
        name: "Account Name",
        field: "name_on_account"
      },

      {
        name: "Bank Name",
        field: "bank_name"
      },

      {
        name: "Mandate Id",
        field: "mandate_id"
      },

      {
        name: "Account Type",
        field: "account_type"
      },

      {
        name: "eCheck Type",
        field: "account_type",
        displayer: function(val) {
          return initCap(val);
        }
      },

      {
        name: "Account Holder Type",
        field: "account_holder_type",
        displayer: function(val) {
          return initCap(val);
        }
      }
    ]
  },
  
  bankAccountInputFields(isAch) {
    return [
      {
        field: "first_name",
        label_key: (isAch) ? "hp_v3.direct_debit.name_on_account" :  "hp_v3.direct_debit.first_name"
      },
      {
        field: "last_name",
        label_key: "hp_v3.direct_debit.last_name"
      },
      {
        field: "company",
        label_key: "hp_v3.direct_debit.company"
      },
      {
        field: "email",
        label_key: "hp_v3.direct_debit.email"
      },
      {
        field: "swedish_identity_number",
        label_key: "hp_v3.direct_debit.swedish_id"
      },
      {
        field: "iban",
        label_key: "hp_v3.direct_debit.iban"
      },
      {
        field: "issuing_country",
        label_key: "hp_v3.direct_debit.country",
        displayer: function(val) {
          let country = CountryCodeList.filter(f => f.value == val)[0];
          return country && country.display_name;
        }
      },
      {
        field: "account_holder_type",
        label_key: "hp_v3.direct_debit.account_holder_type",
        displayer: function(val) {
          return initCap(val);
        }
      },
      {
        field: "account_type",
        label_key: "hp_v3.direct_debit.account_type",
        displayer: function(val) {
          return initCap(val);
        }
      },
      {
        field: "bank_name",
        label_key: "hp_v3.direct_debit.bank_name"
      },
      {
        field: "account_number",
        label_key: "hp_v3.direct_debit.account_number"
      },
      {
        field: "bank_code",
        label_key: "hp_v3.direct_debit.bank_code"
      },
      {
        field: "routing_number",
        label_key: (isAch) ? "hp_v3.direct_debit.routing_number" : "hp_v3.direct_debit.branch_code"
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/utils/payment-method-displayer.js